export const IS_SPECIAL = process.env.REACT_APP_WORKSPACE === 'special'

export default function SpecialBadge() {
  if (!IS_SPECIAL) return null
  return (
    <span style={{
      fontSize: 11, fontWeight: 700, letterSpacing: '0.5px',
      color: '#fff', background: 'linear-gradient(135deg, #7c5fe6, #a855f7)',
      borderRadius: 20, padding: '3px 10px', marginLeft: 8, textTransform: 'uppercase',
      flexShrink: 0,
    }}>Особая</span>
  )
}
